export const SENTIMENT_CLASSES = {
  positive: "bg-pos-bg text-pos-text border-pos-border",
  neutral: "bg-neu-bg text-neu-text border-neu-border",
  negative: "bg-neg-bg text-neg-text border-neg-border",
};

export const SENTIMENT_HEX = {
  positive: "#1E7E34",
  neutral: "#B8860B",
  negative: "#C0392B",
};

export const ROLE_BADGE = {
  admin: "bg-brand-red/10 text-brand-red border-brand-red/20",
  manager: "bg-brand-navy/10 text-brand-navy border-brand-navy/20",
  staff: "bg-brand-blue/10 text-brand-blue border-brand-blue/20",
  observer: "bg-slate-100 text-slate-600 border-slate-200",
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString();
}

export function titleCase(s) {
  return (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function fmtMoney(n) {
  return `$${Number(n || 0).toFixed(4)}`;
}

export const SOURCE_ICON = {
  news: "Newspaper",
  reddit: "MessageSquare",
  bluesky: "Cloud",
  mastodon: "AtSign",
};
